export default {"src":"/_next/static/media/toggleswitch.424f3f75.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};